import "./advancedSearch.css";
import React from "react";
import { Form, Container, Button, ButtonToolbar } from "react-bootstrap";
import { _t } from "../../app/i18n/i18n";
import { gotoSearchResultsPage } from "../search/api/filterUrlMaker";
import { Keywords } from "./parts/Keywords";
import { ReportFilters } from "./parts/ReportFilters";
import { AnalystCompany } from "./parts/AnalystCompany";
import { Exclusions } from "./parts/Exclusions";
import { Accordian } from "./parts/Accordian";
import { createFiltersFromForm } from "./parts/util";

export const AdvancedSearch = () => {
  return (
    <Form onSubmit={(e) => submit(e)} style={{ fontSize: "0.76563rem" }}>
      <Container fluid className="pt-3">
        <Accordian title={_t("Keywords")} defaultOpen={true}>
          <Keywords />
        </Accordian>

        <Accordian title={_t("Report Properties")}>
          <ReportFilters />
        </Accordian>

        <Accordian title={_t("Analyst, Company and Sector")}>
          <AnalystCompany />
        </Accordian>

        <Accordian title={_t("Exclusions")}>
          <Exclusions />
        </Accordian>

        {/* <LinkContainer to={"/advanced-search/search-history"}>
          <Nav.Link href="#" className="text-info pl-0"><h6><u>{_t("Search History")}</u></h6></Nav.Link>
        </LinkContainer>

        <LinkContainer to={"/advanced-search/search-history"}>
          <Nav.Link href="#" className="text-info pl-0"><h6><u>{_t("Trending Keywords")}</u></h6></Nav.Link>
        </LinkContainer> */}
      </Container>
      <SubmitButton />
    </Form>
  );
};

const SubmitButton = () => (
  <div className="d-block clearfix mb-3">
    <ButtonToolbar className="float-right d-block clearfix m-2">
      <Button type="submit" size="lg" variant="secondary" className="mr-2">
        {<i className="fa fa-arrow-left fa-fw m-1" />}
        {"Back"}
      </Button>
      <Button type="submit" size="lg" className="mr-5">
        {<i className="fa fa-search fa-fw m-1" />}
        {_t("Please search")}
      </Button>
    </ButtonToolbar>
  </div>
);

const submit = (e) => {
  e.preventDefault();
  createFiltersFromForm(e);
  gotoSearchResultsPage();
};
